// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-icon{display:inline-block;color:inherit;vertical-align:middle;fill:none;stroke:currentColor}.svg-fill{fill:currentColor;stroke:none}.svg-fill-stroke,.svg-fill-stroke .svg-icon{fill:currentColor;stroke:currentColor}.svg-up{transform:rotate(0deg)}.svg-right{transform:rotate(90deg)}.svg-down{transform:rotate(180deg)}.svg-left{transform:rotate(-90deg)}", ""]);
// Exports
module.exports = exports;
